import { Common, color } from '@stockbit/ui';
import Image from 'global/Image';
import { ProgressRejectedAuthModalContainer } from './styled';
import useAuthModalStore from './store';
import { AuthModalProps } from './types';

const { Flex, Text, Button } = Common;

export default function RejectedAuthModal({ visible }: AuthModalProps) {
  const closeModal = useAuthModalStore((state) => state.closeModal);

  return (
    <ProgressRejectedAuthModalContainer
      data-cy="rejected-auth-modal"
      visible={visible}
      centered
      width={364}
      onCancel={closeModal}
    >
      <Flex direction="column" justify="center" align="center">
        <Image src="/img/stockbit-qr.svg" alt="stockbit app qr code" />
        <Text align="center" mt="2px" mb="30px">
          Scan QR Code
        </Text>
        <Text family="bold" size="16px" align="center" mb="13px">
          Verifikasi Data Belum Berhasil
        </Text>
        <Text align="center" mb="30px" color={color.highgray}>
          Silakan scan QR Code di atas atau buka aplikasi Stockbit kamu dan
          perbaiki data sesuai dengan instruksi.
        </Text>
        <Button
          type="primary"
          width="100%"
          radius="4px"
          onClick={closeModal}
          data-cy="rejected-auth-modal-btn"
        >
          <Text family="bold" color={color.light} padding="12px">
            Oke
          </Text>
        </Button>
      </Flex>
    </ProgressRejectedAuthModalContainer>
  );
}
